import { jsx as _jsx } from "react/jsx-runtime";
import { Code, LanguageOutlined, Web } from "@mui/icons-material";
import { EmptyState } from "../../shared/EmptyState";
export const WebsiteLeadEmptyState = ({ onAddCode }) => {
    return (_jsx(EmptyState, { backgroundIcon: Web, primaryIcon: LanguageOutlined, accentIcon: Code, title: "No Website Leads Yet", description: "Add our lead form to your website by embedding the provided code. When visitors fill out the form on your site, their information will appear here automatically.", action: onAddCode
            ? { label: "Get Embedded Code", onClick: onAddCode }
            : undefined }));
};
